<template>
    <div class="ui-panel">
        <div class="panel-header">
            <div class="panel-icon"><i class="nucfont" :class="icon"></i></div>

            <!-- 不知道为什么用之前的具名插槽写法会undefined -->
            <slot name="title" v-if="$slots.title"></slot>

            <template v-else-if="title">
                <span class="panel-title">{{title}}</span>
                <slot name="button"></slot>
            </template>
        </div>

        <div class="panel-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        icon: String,
    },
    data() {
        return {

        }
    },
    created() {
    },
    computed: {

    },
    methods: {

    },
    components: {
    }
}
</script>

<style lang="scss">
    @import '../style/const.scss';

    .ui-panel {
        @include scrollbar();
        border: 1px solid $c-border;

        .panel-header {
            position: relative;
            display: flex;
            align-items: center;
            height: 40px;
            background-color: #f4f3f8;
            border-bottom: 1px solid $c-border;
            flex-shrink: 0;

            .panel-title {
                font-size: 16px;
                padding-left: 15px;
                flex-shrink: 0;
            }

            .panel-icon {
                width: 45px;
                border-right: 1px solid $c-border;
                text-align: center;
                color: #1c84c6;
                .nucfont {
                    font-size: 20px
                }
            }

            .operate {
                position: absolute;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                .nucfont {
                    color: #a3a4a9;
                    font-size: 18px;
                    cursor: pointer;
                    &:hover {
                        color: $blue;
                    }
                }
            }
        }

        .panel-body {
            flex: 1;
            padding: 15px;
            color: #333;
            border-radius: 4px;
            background-color: #fff;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }
</style>
